/**
 * Query-key prefixes for the dual-path trait operations, for the rare call site
 * that invalidates a specific trait query instead of relying on the global
 * post-mutation invalidation. Both paths' keys have to be named: the caller
 * can't know which one served the cached data. Collapses to the single new-path
 * key once appUseNewTraitsEndpoints is retired.
 */
export const traitQueryKeys = {
  traitsForParentModel: [
    "TraitsForParentModel",
    "TraitsForParentModelLegacy",
  ] as const,
};
